export const assignmentsSelector = (assignmentsObj) => {
  return Object.keys(assignmentsObj)
    .map((assignmentKey) => assignmentsObj[assignmentKey]).sort((a,b) => a.id < b.id);
};
